import React, { memo } from 'react';
import CircularProgressIndicator from '@/app/components/circular_progress_indicator';
import useProfile from '@/app/features/profile/slice';
import { useMediaQuery } from '@/app/utils/custom_function';

// Import view components
import ProfileMobileView from './components/profile_mobile_view';
import ProfileDesktopView from './components/profile_desktop_view';

/**
 * Profile page component
 * Renders different views based on device type
 */
const Profile = () => {
  const isDesktop = useMediaQuery('(min-width:1024px)');
  
  const {
    state,
    goToOnboarding,
    setIsEdit,
    setName,
    onSelect,
    setPadelSkillLevel,
    setNtrpRating,
    setPadelClubMembership,
    setPlayingFrequency,
    setDateOfBirth,
    toggleShowInProfileDateOfBirth,
    setGender,
    setAboutMe,
    setIndustry,
    setInstagram,
    setLinkedin,
    toggleOpenQuestionnaire,
    uploadPhoto,
    onSave,
    onLogout,
    toggleShowWantToLeave
  } = useProfile();

  // Show loading indicator while data is being fetched
  if (state.hasLoading || !state.user) {
    return <CircularProgressIndicator isGreen />;
  }

  // Actions object to pass to view components
  const actions = {
    goToOnboarding,
    setIsEdit,
    setName,
    onSelect,
    setPadelSkillLevel,
    setNtrpRating,
    setPadelClubMembership,
    setPlayingFrequency,
    setDateOfBirth,
    toggleShowInProfileDateOfBirth,
    setGender,
    setAboutMe,
    setIndustry,
    setInstagram,
    setLinkedin,
    toggleOpenQuestionnaire,
    uploadPhoto,
    onSave,
    onLogout,
    toggleShowWantToLeave
  };

  // Render appropriate view based on device type

  return isDesktop
    ? <ProfileDesktopView state={state} actions={actions} />
    : <ProfileMobileView state={state} actions={actions} />;
};

export default memo(Profile);